export default __webpack_public_path__ + "static/samokat_product_3-8a91c4077bcc123a4ef5daa8b62297a6.png";